import { useCallback, useRef, useState } from "react";

export function useMaximizedModal(trackingKey: unknown) {
    const [isMaximized, setIsMaximized] = useState(false);
    const prevKeyRef = useRef(trackingKey);

    if (prevKeyRef.current !== trackingKey) {
        prevKeyRef.current = trackingKey;
        setIsMaximized(false);
    }

    const toggleMaximized = useCallback(
        () => setIsMaximized((prev) => !prev),
        [],
    );

    return { isMaximized, toggleMaximized };
}
